import { COPY_POLICIES, DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const HERO_CENTERED_MAX_LENGTHS = {
    heading: COPY_POLICIES.title.maxLength,
    subheading: COPY_POLICIES.description.maxLength,
};
export const heroCenteredSchema = {
    componentId: "HeroCentered",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        {
            key: "heading",
            ...TITLE_COPY_LIMITS,
            label: "Heading",
            type: "text",
        },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Subheading",
            type: "textarea",
        },
    ],
    mediaSlots: [],
};
//# sourceMappingURL=hero-centered.js.map